import * as superagent from 'superagent';
import { formatMoney } from '../../../utils/format_money';
import { declension } from '../../../utils/declension';

export function sectionBrandingMiddleware(meta: any): Promise<any> {
  if (!meta.newBuildingId || meta.info) {
    return Promise.resolve(Object.assign({}, meta, { infoText: meta.info }));
  }

  return new Promise((resolve, reject) => {
    superagent
      .get('/ajax/sections_housing_info/')
      .query({id: meta.newBuildingId})
      .end((err, res) => {
        if (err) {
          resolve(Object.assign({}, meta, {
            infoText: meta.info || ''
          }));
          return;
        }

        if (res.body && res.body.status && res.body.status.toLowerCase() === 'ok') {
          resolve(Object.assign({}, meta, {
            infoText: `В продаже ${formatMoney(res.body.data.offers_count)} ${declension(res.body.data.offers_count, (meta.isApartment ? ['апартамент', 'апартамента', 'апартаментов'] : ['квартира','квартиры','квартир']))} по цене от ${formatMoney(res.body.data.min_price2)} ₽`
          }));
          return;
        }

        resolve(Object.assign({}, meta, {
          infoText: meta.info || ''
        }));
      })
  })
}



// WEBPACK FOOTER //
// ./src/bundles/mainpage/adfox_middlewares/section_branding.ts